import { render, staticRenderFns } from "./errNetwork.vue?vue&type=template&id=5b2b189f"
import script from "./errNetwork.vue?vue&type=script&lang=js"
export * from "./errNetwork.vue?vue&type=script&lang=js"
import style0 from "./errNetwork.vue?vue&type=style&index=0&id=5b2b189f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports